/* eslint-disable array-callback-return */
import React from 'react';
import {Route, Routes} from "react-router-dom";
import {IPage, pages} from '../../pages/pagesConfig';
import RecoveryPassword from "../../pages/RecoveryPassword/RecoveryPassword";

const AppRouter = () => {

    return (
        <Routes>

            {/*Мапинг основных страниц*/}
            {pages.map((page: IPage, index) => {
                if (page.status) {
                    return (
                        <Route
                            key={`route_${index}`}
                            path={page.path}
                            element={page.element}/>
                    )
                }
            })}

            {/*Страница со сменной пароля*/}
            <Route path={'/password_recovery'}>
                <Route path={':recoveryKey'} element={<RecoveryPassword />}/>
            </Route>

        </Routes>
    );
};

export default AppRouter;